/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorLabDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Lab'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (!pInput.PictForm)
		{
			pInput.PictForm = { };
		}
		if (pInput.PictForm.Multiple == null)
		{
			pInput.PictForm.Multiple = true;
		}
		if (pInput.PictForm.Multiple)
		{
			// update the parent ".control.select" to have ".is-multiple" for proper styling
			const tmpSelectWrapper = document.querySelector(`${pHTMLSelector} ~ .field .control.select`);
			if (tmpSelectWrapper && !tmpSelectWrapper.classList.contains('is-multiple'))
			{
				tmpSelectWrapper.classList.add('is-multiple');
			}
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = MaterialsSelectorLabDisplayInputHandler;
